"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var moment_1 = __importDefault(require("moment"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var CardActionsInfo = function (_a) {
    var subjectName = _a.subjectName, infoDate = _a.infoDate, _b = _a.additionalStyles, additionalStyles = _b === void 0 ? '' : _b;
    return (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.card_actions_info_box, {
            additionalStyles: additionalStyles,
        }) },
        react_1.default.createElement("p", null, subjectName),
        react_1.default.createElement("p", null, moment_1.default(infoDate).format('M/D/Y'))));
};
exports.default = react_1.memo(CardActionsInfo);
